import { useCallback, useState } from "react";
import ReactS3Client from "react-aws-s3-typescript";
import { Modal } from "react-bootstrap-v5";
import { IEmpresas } from "../../interfaces/IEmpresas";
import ImportarService from "../../services/ImportarService";
import { configBucket } from "../../utils/S3Utils";

const ModalImportacaoPosicaoFinanceira = ({ toggleModal, show, title, empresaID }: { toggleModal: () => void, show: boolean, title: string, empresaID: number }) => {

    const [file, setFile] = useState<File>();
    const [loading, setLoading] = useState<boolean>(false);
    
    const handleUploadFile = useCallback((fileParam: File) => {
        setFile(fileParam);
    }, []);

    const sendFile = useCallback(async () => {
        try {
            if (file) {
                setLoading(true);
                const s3 = new ReactS3Client(configBucket);
                const res = await s3.uploadFile(file, file.name);
                await ImportarService.enviarPosicaoFinanceira(empresaID, res.location, 'clientefornecedor');
                setLoading(false);
            }
        } catch (err) {
            throw new Error('Ocorreu um erro ao fazer o upload do arquivo, entre em contato com o suporte ou tente novamente mais tarde!');
        }
    }, [file, empresaID]);

    return <Modal maxwidth= '600px' centered={true} show={show} onHide={toggleModal}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{title}</h5>
        </div>
        <div className="modal-body">
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        <label>Selecione o arquivo</label>
                        <input accept=".csv,.xlsx,.xls" className="form-control" type="file" onChange={(e) => {
                            if (e.target.files !== null && e.target.files.length > 0) {
                                const file = e.target.files[0];
                                handleUploadFile(file);
                            }
                        }}  />
                    </div>
                </div>
                <div className="col-md-12 mt-4">
                    <button type="button" className="btn btn-success" onClick={() => sendFile()}>
                        {loading ? 'Enviando...' : 'Enviar'}
                    </button>                        
                </div>
            </div>
        </div>
        <div className="modal-footer" style={{ margin: '0 auto' }} />
      </div>
    </Modal>
  }

const defaultModalState = { 
    title: '',
    show: false,
    selected: ''
};
  
function Importacao({ empresa }: { empresa: IEmpresas | undefined }) {

    const [modal, setModal] = useState<any>(defaultModalState);

    const resetModal = useCallback(() => {
        setModal(defaultModalState)
    }, []);

    const showModal = useCallback((title, selected) => {
        setModal({
            title,
            selected,
            show: true
        });
    }, []);

    return <>
        <ModalImportacaoPosicaoFinanceira empresaID={empresa?.id || 0} title={modal.title} show={modal.show} toggleModal={() => resetModal()} />
        {
            <div className="row mt-5">
                <div className="col-md-3">
                    <div className="card" style={{ width: '100%', border: '1px solid #005E96' }}>
                        <div className="card-body">
                            <h5 className="card-title">Posição Financeira</h5>
                            <h6 className="card-subtitle mb-2 text-muted">Formatos suportados: csv, xls e xlsx.</h6>
                            <button className="btn" onClick={() => showModal('Posição Financeira', 'posicaofinanceira')}>Importar</button>
                        </div>
                    </div>
                </div>
            </div>
        }
    </>
};

export default Importacao;

